import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const ClockBordered = (props: Icon): React.ReactElement => {
  return (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          d="M12 4a8 8 0 110 16 8 8 0 010-16zm0 1.333a6.667 6.667 0 100 13.334 6.667 6.667 0 000-13.334zm0 1.334a5.333 5.333 0 110 10.666 5.333 5.333 0 010-10.666zM12 8a4 4 0 100 8 4 4 0 000-8zm0 1.333c.342 0 .624.258.662.59l.005.077v2.667a.667.667 0 01-.59.662l-.077.004h-2a.667.667 0 01-.078-1.329L10 12h1.333v-2c0-.342.258-.624.59-.662L12 9.333z"
          id="clock-bordered-a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="clock-bordered-b" fill="#fff">
          <use xlinkHref="#clock-bordered-a" />
        </mask>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#clock-bordered-a" />
        <g
          mask="url(#clock-bordered-b)"
          fill={props.color || theme.palette.grey600}
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  );
};
